import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "description" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "catigory" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredData, (item, key, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "block"
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(key)), 1),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.pickupBoxes?.[item])
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass({
              pickupBoxes: true,
              'pickupBoxes-bestCategory': key === 'bestCategory'
            })
                }, _toDisplayString(_ctx.$t('pickupDeliveries')), 3))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              class: _normalizeClass({
              item: true,
              bestCategory: key === 'bestCategory'
            })
            }, _toDisplayString(key === 'mostDissatisfiedCustomersHours'
                ? _ctx.isValidHours(item)
                : _ctx.getCategory(item)), 3)
          ])
        ]))
      }), 128))
    ])
  ]))
}